import { render, staticRenderFns } from "./MainStepMyTask.vue?vue&type=template&id=20e4e8f8"
import script from "./MainStepMyTask.vue?vue&type=script&lang=js"
export * from "./MainStepMyTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports